const tableNames = [
    '',
    'CalibrationGeneral',
    'CalibrationBonus',
    'CalibrationOfficeCommercial',
    'CalibrationParking',
    'CalibrationUsesVals',
    'BuildingTypology',
    'OverlayTypology'
];

// This enum is related to TableType table and should be synchronized with it
export enum TableType {
    NONE,
    CALIBRATION_GENERAL,
    CALIBRATION_BONUS,
    CALIBRATION_USE_CAPACITY,
    CALIBRATION_PARKING,
    CALIBRATION_USES,
    VIRTUAL_BUILDING_TYPOLOGY,
    OVERLAY_TYPOLOGY,
    ZONE_COMBINATION,
    ZONING_CODE_SETTINGS,
    PROXIMITY_CONDITION,
    FRONTAGE_BUNDLE
}

export function getTableTypeByEntityName(value: string): number {
    return tableNames.indexOf(value);
}

export function getEntityName(value: number): string {
    return tableNames[value];
}

export enum AttributesStatisticCollectionNames {
    ZONING_CODE_ATTRIBUTES_STATISTICS = 'ZoningCodeAttributesStatistics',
    CALIBRATION_SETS_ATTRIBUTES_STATISTICS = 'CalibrationSetsAttributesStatistics',
    CALIBRATION_SET_TABLE_FIELDS_ATTRIBUTES_STATISTICS = 'CalibrationSetTableFieldsAttributesStatistics',
    CALIBRATION_USES_LABELS = 'CalibrationUsesLabels',
}
